import { createFileRoute, redirect } from "@tanstack/react-router";

/** The singular spelling, kept working because somebody typed it once. */
export const Route = createFileRoute("/_authenticated/_front-desk/call-log")({
  beforeLoad: () => {
    throw redirect({ to: "/call-logs" });
  },
});
